import { useEffect, useState } from 'react';

import { getUtmsFromSession } from 'lib/sessionStorage';

const useUtmsFromSession = () => {
  const [utmParams, setUtmParams] = useState('');

  useEffect(() => {
    setUtmParams(new URLSearchParams(getUtmsFromSession()).toString());
  }, []);

  return { utmParams };
};

export default useUtmsFromSession;
